
export const CLEAR = 'map/CLEAR';

export const clear = () => ({
    type: CLEAR
});

export const CHANGE_VIEW = 'map/CHANGE_VIEW';

export const changeView = (center, zoom, rotation) => ({
    type: CHANGE_VIEW,
    center,
    zoom,
    rotation
});

export const INIT_PROJECT = 'map/INIT_PROJECT';

export const initProject = (project) => ({
    type: INIT_PROJECT,
    project
});

export const SET_LAYER_VISIBILITY = 'map/SET_LAYER_VISIBILITY';

export const setLayerVisibility = (id, visibility) => ({
    type: SET_LAYER_VISIBILITY,
    id,
    visibility
});

export const REQUEST_GET_INFO = 'map/REQUEST_GET_INFO';
export const RESPONSE_GET_INFO = 'map/RESPONSE_GET_INFO';

export const getInfo = (coord, layers, resolution) => {
    return (dispatch) => {
        dispatch(requestGetInfo());
        fetch(`/api/map/getinfo/?coord=${coord}&layers=${layers}&res=${resolution}`)
            .then(response => response.json())
            .then(data => {
                dispatch(responseGetInfo({
                    data: data
                }));
            })
            .catch((e) => {
                dispatch(responseGetInfo({
                    data: {}
                }));
            });
    }
}

const requestGetInfo = (coord) => ({
    type: REQUEST_GET_INFO,
    coord
});

const responseGetInfo = (res) => ({
    type: RESPONSE_GET_INFO,
    error: res.error,
    data: res.data
});

export const SET_MAP_POINTS = 'map/SET_MAP_POINTS';

export const setMapPoints = (points) => ({
    type: SET_MAP_POINTS,
    points
});

export const REQUEST_GET_LEGEND = 'map/REQUEST_GET_LEGEND';
export const RESPONSE_GET_LEGEND = 'map/RESPONSE_GET_LEGEND';

export const getLegend = () => {
    return (dispatch) => {
        dispatch(requestGetLegend());
        fetch(`/api/map/getlegend`)
            .then(response => response.json())
            .then(data => {
                dispatch(responseGetLegend({
                    data: data
                }));
            })
            .catch((e) => {
                dispatch(responseGetLegend({
                    data: ''
                }));
            });
    }
}

const requestGetLegend = (coord) => ({
    type: REQUEST_GET_LEGEND,
    coord
});

const responseGetLegend = (res) => ({
    type: RESPONSE_GET_LEGEND,
    error: res.error,
    data: res.data
});
